module.exports = __webpack_public_path__ + "static/media/widget15-img.3d6f3748.png";